module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Beach/Kanagawa_Beach_GFDL_RCP45_Now.png";